export const faq = [
	{
		question: 'How to make order?',
		answer: 'You should choose products and make an order via basket!',
	},
	{
		question: 'How long does delivery takes?',
		answer: 'It depends on your location. The max delivery time is 1 hour!',
	},
	{
		question: 'Is our details secure in this platform?',
		answer: 'Of course, we take full responsibility for your provided user details!',
	},
	{
		question: 'I am blocked, what should I do?',
		answer: 'There is a reason for your block, please contact to us!',
	},
	{
		question: 'How can I cancel order?',
		answer: 'You can cancel your order any time easily, just go to your orders page!',
	},
	{
		question: 'Who developed this platform?',
		answer: 'ITC Global developers developed this platform!',
	},
];
